import ScrollMagic from 'scrollmagic';
import $ from 'jquery';
import {debounce, throttle} from 'lodash';
import {breakpointUp, breakpointDown} from './Breakpoints';

let ScrollMagicGE = {

    controller: new ScrollMagic.Controller(),
    weekNavScene: null,
    windowHeightSize: null,
    searchFormDuration: null,
    menuOffsetPos: 0,
    scrollPos: 0,

    init: function () {
        this.resizeHeightEvent();
        this.menu();

        $('body').hasClass('home') ? [this.homeMountains(), this.homeBear()] : null;

    },
    menu: function () {

        let lastDirection = 'REVERSE';

        let hideMenu = throttle(function (direction, hideOkToggle) {

            $('header .wrap-nav-bar').fadeOut(200);

            lastDirection = 'FORWARD';

        }, 100);

        let showMenu = throttle(function (direction, hideOkToggle) {

            $('header .wrap-nav-bar').fadeIn(200);

            lastDirection = 'REVERSE';

        }, 100);


        let fadeActionWrapMenu = throttle(function (direction, hideOkToggle) {

            if (direction === 'FORWARD' && lastDirection === 'REVERSE' && hideOkToggle) {
                hideMenu();
            }
            if ((direction === 'REVERSE' && lastDirection === 'FORWARD') && (!hideOkToggle || breakpointDown('md') )) {
                showMenu();
            }

        }, 100);


        let fadeActionLogo = throttle(function (showOkLogo) {

            if (showOkLogo) {
                $('.nav-bar .logoGE').addClass('show');
            } else {
                $('.nav-bar .logoGE').removeClass('show');
            }

        }, 100);


        // Scene Bouton Menu Switch
        let menuScene = new ScrollMagic.Scene({
            triggerElement: 'body',
            triggerHook: 0,
            duration: 0,    // the scene should last for a scroll distance of
                            // 100px
            offset: 5,        // start this scene after scrolling for 50px
        })
            .setClassToggle('header .top-header, header .wrap-nav-bar, .toggle-mobile', 'switch')
            // .addIndicators()
            .addTo(this.controller)
            .on("update", (e) => {
                var direction = this.controller.info("scrollDirection");
                let hideOkToggle = (e.scrollPos >= e.startPos);
                let showOkLogo = (e.scrollPos <= 40);
                this.scrollPos = e.scrollPos;

                fadeActionWrapMenu(direction, hideOkToggle);
                fadeActionLogo(showOkLogo);
            }); // assign the scene to the controller

        /*        $(window).bind('resizeEnd', () => {
                    this.menuOffsetPos = breakpointDown('md') ? 10 : 150;
                    menuScene.offset(this.menuOffsetPos);

                });*/


    },
    resizeHeightEvent: function () {

        this.windowHeightSize = $(window).height();

        $(window).resize(() => {
            if ($(window).height() === this.windowHeightSize) return;
            this.windowHeightSize = $(window).height();
        });
    },
    homeBear() {

        let getDuration = () => {
            return this.windowHeightSize * 0.3;
        };

        new ScrollMagic.Scene({
            triggerElement: '.magazine-home',
            triggerHook: 0.7,
            duration: getDuration,
            offset: 0,
        })
            .addTo(this.controller)
            //.addIndicators() // add indicators (requires plugin)
            .on("progress", function (e) {
                let heightBgLeft = 10 - (e.progress * 10);
                let heightOurs = 20 - (e.progress * 20);

                $('section.magazine-home .bg-left').css({
                    'transform': 'translateY(' + heightBgLeft + '%)',
                    '-webkit-transform': 'translateY(' + heightBgLeft + '%)',
                });

                $('section.magazine-home .ours').css({
                    'transform': 'translateY(' + heightOurs + '%)',
                    '-webkit-transform': 'translateY(' + heightOurs + '%)',
                });

            });
    },
    homeMountains: function () {

        let getDuration = () => {
            return this.windowHeightSize * 0.5;
        };

        new ScrollMagic.Scene({
            triggerElement: '.home-mountains .mountains',
            triggerHook: 0.8,
            duration: getDuration,
            offset: 0,
        })
            .addTo(this.controller)
            // .addIndicators() // add indicators (requires plugin)
            .on("progress", function (e) {
                let translateMountainsFar = (e.progress * -80);
                let translateMountainsLeft = (e.progress * -50);
                let translateMountainsRight = (e.progress * -40);
                let heightVoyager = (e.progress * 60) + 40;


                $('div.mountains .voyager').css({
                    'height': heightVoyager + '%',
                });

                $('div.mountains .mountains-far').css({
                    'transform': 'translateY(' + translateMountainsFar + 'px)',
                    '-webkit-transform': 'translateY(' + translateMountainsFar + 'px)',
                });

                $('div.mountains .mountains-left').css({
                    'transform': 'translateY(' + translateMountainsLeft + 'px)',
                    '-webkit-transform': 'translateY(' + translateMountainsLeft + 'px)',
                });

                $('div.mountains .mountains-right').css({
                    'transform': 'translateY(' + translateMountainsRight + 'px)',
                    '-webkit-transform': 'translateY(' + translateMountainsRight + 'px)',
                });

            })
            .on("update", function (e) {

                let translateVoyager = 0;

                if (e.scrollPos <= e.startPos) {
                    translateVoyager = 0;
                } else {
                    translateVoyager = -(e.scrollPos - e.startPos) * 0.8;

                }

                $('div.mountains .voyager').css({
                    'transform': 'translate(-50%,' + translateVoyager + 'px)',
                    '-webkit-transform': 'translate(-50%,' + translateVoyager + 'px)',
                });

            });


    },
    searchCruiseForm: function () {
        this.searchFormDuration = $('div.results').height() - $('div.search-form').outerHeight() - parseInt($('article.cruise-card').css('margin-bottom'));

        let offset = $('.nav-bar').height();

        let translateHeight = 0;

        let first = true;

        let searchCruiseFormScene = new ScrollMagic.Scene({
            triggerElement: '.list-destinations',
            triggerHook: 0,
            duration: this.searchFormDuration,
            offset: -offset - 60,
        })
            .addTo(this.controller)
            // .addIndicators() // add indicators (requires plugin)
            .on("progress", function (e) {

                translateHeight = (window.breakpointDownLg || first) ? 0 : (e.progress * ScrollMagicGE.searchFormDuration);


                $('div.search-form').css({
                    'transform': 'translateY(' + translateHeight + 'px)',
                    '-webkit-transform': 'translateY(' + translateHeight + 'px)',
                });

                first = false;

            });

        $(window).bind('resizeEnd', () => {

            this.searchFormDuration = $('div.results').height() - $('div.search-form').outerHeight() - parseInt($('article.cruise-card').css('margin-bottom'));

            searchCruiseFormScene.duration(this.searchFormDuration);


            setTimeout(function () {

                let offset = window.breakpointDownLg ? 0 : $('.nav-bar').height();

                searchCruiseFormScene.offset(-offset - 60);

                if (window.breakpointDownLg) {
                    translateHeight = 0;

                    $('div.search-form').css({
                        'transform': 'translateY(' + translateHeight + 'px)',
                        '-webkit-transform': 'translateY(' + translateHeight + 'px)',
                    });

                }
            }, 300);

        });

    },
    weekNav: function () {

        let duration = $('div.content-wrapper').height() - $('nav.week-nav').outerHeight() - parseInt($('article.one-week').css('margin-bottom')) - 30;
        let offset = $('.nav-bar').height();

        this.controller.removeScene(this.weekNavScene);

        this.weekNavScene = new ScrollMagic.Scene({
            triggerElement: '.single-travelogue-content',
            triggerHook: 0,
            duration: duration,
            offset: -offset - 60,
        })
            .addTo(this.controller)
            // .addIndicators() // add indicators (requires plugin)
            .on("progress", function (e) {
                let translateHeight = e.progress * duration;
                // console.log(translateHeight);

                $('nav.week-nav').css({
                    'transform': 'translateY(' + translateHeight + 'px)',
                    '-webkit-transform': 'translateY(' + translateHeight + 'px)',
                });

            });

    },
    backToTop: function () {

        new ScrollMagic.Scene({
            triggerElement: 'body',
            triggerHook: 0,
            duration: 0,
            offset: 1600,
        })
            .on("enter", debounce(function (e) {
                $('.back-to-top').css("display", "flex").hide().fadeIn(400).addClass('show');

            }, 200))
            .on("leave", debounce((e) => {
                this.backToTopLeave();

            }, 800))
            // .addIndicators()
            .addTo(this.controller); // assign the scene to the controller

    },
    backToTopLeave: function () {
        $('.back-to-top').fadeOut(200).removeClass('show');
    },

};

export default ScrollMagicGE;


// WEBPACK FOOTER //
// ./assets/js/libs/ScrollMagicGE.js